import yn from "yn";

const { VITE_AI_ASSISTANT_ENABLED } = import.meta.env;

/**
 * Global kill switch for the AI Analysis Assistant. Set VITE_AI_ASSISTANT_ENABLED=false
 * in .env to disable across all customers, or in a customer-specific env file
 * (e.g. customer/<name>/product/sc-frontend/config/.env.production) to disable for a
 * single customer. Both require a CI/deploy cycle to take effect.
 *
 * Consider migrating to a Flipt flag for runtime toggling once a global (cross-customer)
 * Flipt config exists.
 */
export function useAiAssistantEnabled(): boolean {
  return yn(VITE_AI_ASSISTANT_ENABLED, { default: true });
}
